import type { SearchPagination, SearchResponse } from '@algolia/client-search';
import type { RefObject } from 'react';

import type { ApiJobId } from '#/api/types/ApiTypedId';
import type { ApiVolopId } from '#/api/types/ApiTypedId';
import type { ScrollAreaHandle } from '#/components/ScrollArea/ScrollArea';
import type { SearchAlgoliaHit } from '#/modules/search/algolia/types/SearchAlgoliaHit';
import { SearchLoadingSectionMockResults } from '#/modules/search/components/Loading/SearchLoadingSectionMockResults';
import type { SearchContextHeaderData } from '#/modules/search/containers/SearchContextHeader/SearchContextHeaderData';
import {
  type SearchSavedListingsStore,
  useSearchSavedListingsSyncAlgoliaHits,
} from '#/modules/search/zustand-stores/searchSavedListingsStore';

import { ViewListingPageSidebarPaginationHolder } from './ViewListingPageSidebarPagination.styled';
import { ViewListingPageSidebarPaginationHits } from './ViewListingPageSidebarPaginationHits';

type Props = {
  listingId: ApiJobId | ApiVolopId;
  results?: SearchResponse<SearchAlgoliaHit> & Required<SearchPagination>;
  searchContext: SearchContextHeaderData;
  searchSavedListingsStore: SearchSavedListingsStore;
  scrollingParentRef: RefObject<ScrollAreaHandle | null>;
};

export function ViewListingPageSidebarPagination({
  listingId,
  results,
  searchContext,
  scrollingParentRef,
  searchSavedListingsStore,
}: Props) {
  useSearchSavedListingsSyncAlgoliaHits({
    hits: results?.hits,
    searchSavedListingsStore,
  });

  return (
    <ViewListingPageSidebarPaginationHolder>
      {results ? (
        <ViewListingPageSidebarPaginationHits
          selectedListingId={listingId}
          selectedListingPage={results.page}
          queryID={results.queryID}
          selectedListingPageHits={results.hits}
          totalPages={results.nbPages}
          searchContext={searchContext}
          scrollingParentRef={scrollingParentRef}
          searchSavedListingsStore={searchSavedListingsStore}
        />
      ) : (
        <SearchLoadingSectionMockResults items={3} />
      )}
    </ViewListingPageSidebarPaginationHolder>
  );
}
